import template from './signature-block.signature-item.html';
import photo from './photo/signature-item.photo.js';
import draw from './draw/signature-item.draw.js';
import select from './select/signature-item.select.js';

export default angular
  .module(
    'doxy.realtime.components.teleconsent.action.document.page.signature-block.signature-item',
    [photo, draw, select]
  )
  .component('tcSignatureItem', {
    //tc-signature-item
    template,
    require: {
      form: '?^^form',
    },
    bindings: {
      me: '<',
      data: '<',
      field: '<',
      element: '<',
    },
    controller: function () {
      this.$onInit = function() {
        // Ensure bindings are available before accessing them
        if (this.me && this.field && this.data) {
          this.disabled = !Boolean(this.me) || this.field.editBy !== this.me.type;
          
          if (!Boolean(this.data?.state)) {
            if (Boolean(this.field?.kind)) {
              this.data.state = this.field.kind;
              this.data.isNotCancelable = true;
            } else {
              this.data.state = 'initial';
            }
          }
        } else {
          console.warn('SignatureItem: me, field, or data not available');
        }
      };

      this.checkState = function (state) {
        return this.data.state === state;
      };
    },
  }).name;
